
import { GoogleMap, Marker } from '@react-google-maps/api'// per visualizzare google maps

const mapContainerStyle = { width: '100%', height: '50vh' }   // per google maps

function Geolocation({ lat, center, isReady, readyError, geoloc }) {

    return <>
        <div className='mt-5'>
            <div style={{
                display: `${!lat ? 'flex' : 'none'}`, justifyContent: 'center', position: 'relative', cursor: 'pointer'
            }} onClick={geoloc}>
                <img src={require('../../image/google_maps.webp')} width={220} alt='' />
                <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)', top: '50%', left: '50%', color: 'white', fontSize: '22px' }}>
                    <b>👉 GOOGLE MAPS</b>
                </div>
            </div>
            {lat &&
                <div>
                    {readyError ? <div>Google Maps error</div> : !isReady ? <div>Caricamento Google Maps</div> :
                        <div style={{ border: '1px solid grey', marginTop: '1rem' }}>
                            <GoogleMap mapContainerStyle={mapContainerStyle} zoom={10} center={center}>
                                <Marker position={center} />
                            </GoogleMap>
                        </div>
                    }
                </div>
            }
        </div>
    </>
}
export default Geolocation